import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";

export const CodeBlock = ({ code, label = "bash", accent = "#00ff66" }) => {
  const [copied, setCopied] = useState(false);
  if (!code) return null;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      toast.error("Could not copy to clipboard");
    }
  };

  return (
    <div className="rounded-lg border border-slate-800 bg-[#05080f] overflow-hidden my-3 shadow-2xl">
      <div className="flex items-center justify-between px-4 py-2 border-b border-slate-800 bg-[#0b111d]">
        <div className="flex items-center gap-2">
          <span className="w-3 h-3 rounded-full bg-[#ef4444]/70" />
          <span className="w-3 h-3 rounded-full bg-[#f59e0b]/70" />
          <span className="w-3 h-3 rounded-full bg-[#00ff66]/70" />
          <span className="ml-3 font-mono text-xs text-slate-500">{label}</span>
        </div>
        <button
          data-testid="copy-code-button"
          onClick={copy}
          className="flex items-center gap-1.5 font-mono text-xs text-slate-400 hover:text-[#00ff66] transition-colors"
        >
          {copied ? <Check size={13} /> : <Copy size={13} />}
          {copied ? "copied" : "copy"}
        </button>
      </div>
      <pre className="p-4 overflow-x-auto text-xs sm:text-sm leading-relaxed" style={{ color: accent }}>
        <code className="font-mono whitespace-pre">{code}</code>
      </pre>
    </div>
  );
};
